import categoryService from '../../services/category'

export default {
  namespaced: true,
  state: {
    categories: []
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories
    }
  },
  actions: {
    refresh: async (context) => {
      const categories = await categoryService
        .getList()
        .catch(
          () => undefined
        )
      context.commit('SET_CATEGORIES', categories || [])
      return categories
    }
  },
  getters: {
    categories: state => state.categories
  }
}
